import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import JoinRewardsCallout from 'JS/components/order/JoinRewardsCallout.vue';
import OrderSummaryLine from 'JS/components/order/OrderSummaryLine.vue';
import RewardsAndOffers from 'JS/cart/components/RewardsAndOffers.vue';
import RewardsBadgeWithColor from 'JS/components/RewardsBadgeWithColor.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import WorkOrder from './WorkOrder.vue';
import WorkOrderPromoOfferDiscountLine from './WorkOrderPromoOfferDiscountLine.vue';
import WorkOrderSubmitButton from './WorkOrderSubmitButton.vue';
import WorkOrderTire from './WorkOrderTire.vue';
import WorkOrderVehicle from './WorkOrderVehicle.vue';
import WorkOrderWrapper from './WorkOrderWrapper.vue';
import { computed, ref } from 'vue';
import { IWorkOrderInstallableProductResource, IWorkOrderSummaryResource, WorkOrderTotalType } from '../../types/session';
import { useBreakpoints } from 'JS/composables/breakpoint';
import { useOrderStore } from '../../state/order';
import { WORK_ORDER_DISCLAIMER_ID } from 'JS/automotive/auto-service-scheduler/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkOrderArea',
  props: {
    orderSummary: null,
    primaryProductInfo: null
  },
  setup(__props: any) {

const props = __props as {
	orderSummary: IWorkOrderSummaryResource;
	primaryProductInfo: IWorkOrderInstallableProductResource | null;
}



const orderStore = useOrderStore();
const { isDesktop } = useBreakpoints();
const potentialRewardsString = computed(() => props.orderSummary.earnableRewardsPoints.toString());

const discountsOpen = ref(false);
const toggleDiscounts = () => discountsOpen.value = !discountsOpen.value;

return { __sfc: true,props, orderStore, isDesktop, potentialRewardsString, discountsOpen, toggleDiscounts, Icon, JoinRewardsCallout, OrderSummaryLine, RewardsBadgeWithColor, TransitionExpand, WorkOrder, WorkOrderPromoOfferDiscountLine, WorkOrderSubmitButton, WorkOrderTire, WorkOrderVehicle, WorkOrderWrapper, WorkOrderTotalType, WORK_ORDER_DISCLAIMER_ID }
}

})